import * as types from '../../constants/actionsType';

const initialState = {
    subMenuOpen: ["Dashboard"],
    sumMenuItem: ["myTeam"]
};


export default function reducer(state = initialState, action = {}) {
    switch (action.type) {

        case types.OPEN_SUBMENU:

            if (action.keyParent != undefined && action.key != undefined) {
                return {
                    ...state,
                    subMenuOpen: [action.key, action.keyParent],
                    sumMenuItem:[action.key]
                }
            } else {
                return {
                    ...state,
                    subMenuOpen: [action.key],
                    sumMenuItem: action.key != "myTeam" ? [] : state.sumMenuItem,
                }
            }


        case types.OPEN_SUBMENU_ITEM:
           if (action.key == state.sumMenuItem[0]) {
                return {
                    ...state,
                    sumMenuItem: []
                }
            }
            else {
                return {
                    ...state,
                    sumMenuItem: [action.key]
                }
            }
        default:
            return state;
    }
}
